// DS10-E Winder
import React from "react";
import { CommonRows, InputRangeRow, MinMaxRow, RunTimeRow, WindingTensionRow } from "./index";

export default function MachineDS10E() {
   return (
      <>
         <InputRangeRow
            titleProp={"Program"}
            descriptionProp={""}
            sizeProp={4}
            typeProp={"text"}
            minProp={1}
            maxProp={9999}
            propertyNameProp={"program"}
            errorDialogueProp={"1-9999 only"}
            floatProp={false}
         />
         <RunTimeRow />
         <InputRangeRow
            titleProp={"Yarn Length"}
            descriptionProp={"yds"}
            sizeProp={4}
            typeProp={"text"}
            minProp={1}
            maxProp={999999}
            propertyNameProp={"yarnLength"}
            errorDialogueProp={"1-999,999 only"}
            floatProp={false}
         />
         <MinMaxRow
            titleProp={"Wind Ratio"}
            descriptionProp=""
            minProp1={1.0}
            maxProp1={12.99999}
            floatProp1={true}
            errorProp1={"1-12.99999 only"}
            minProp2={1.0}
            maxProp2={12.99999}
            floatProp2={true}
            errorProp2={"1-12.99999 only"}
            valueProp1={"windRatioStart"}
            valueProp2={"windRatioEnd"}
            differentDisplayProp1={"Start:"}
            differentDisplayProp2={"End:"}
         />
         <WindingTensionRow />
         <InputRangeRow
            titleProp={"Wraps On Capstan"}
            descriptionProp={""}
            sizeProp={4}
            typeProp={"text"}
            minProp={1}
            maxProp={3}
            propertyNameProp={"capstanWraps"}
            errorDialogueProp={"1-3 only"}
            floatProp={false}
         />
         <CommonRows />
      </>
   );
}
